import * as remoteAction from "../remoteAction";

export type GetCouponsActionSuccess = remoteAction.MerchantRemoteResponse<
  "GET_COUPONS_SUCCESS",
  any
>;
export type GetCouponsActionFailure = remoteAction.MerchantRemoteResponse<
  "GET_COUPONS_FAILURE",
  any
>;
export type GetCouponsActionRequest = remoteAction.MerchantRemoteResponse<
  "GET_COUPONS_REQUEST",
  any
>;

export interface GetCouponsAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_COUPONS_REQUEST";
    success: "GET_COUPONS_SUCCESS";
    failure: "GET_COUPONS_FAILURE";
  };
}

export function getCouponsAction(): GetCouponsAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_COUPONS_FAILURE",
      request: "GET_COUPONS_REQUEST",
      success: "GET_COUPONS_SUCCESS",
    },
    https: true,
    url: `/rewards/coupons`,
  };
}
